import { Global, css } from "@emotion/react";

export const Theme = () => (
  <Global
    styles={css`
      body {
        --primary-primary-erm-green: #007a60;
        --color-main: rgba(58, 123, 213, 1);
        --color-main-brighter: rgba(79, 136, 214, 1);
        --color-background: #ffffff;
        --color-font: #303030;
        --color-button-border: rgb(237, 237, 237);
        --color-button-font: #ffffff;
        --color-error: #d32f2f;
        --color-auth-background: linear-gradient(
          42deg,
          rgba(0, 210, 255, 1) 0%,
          rgba(58, 123, 213, 1) 100%
        );
        --border-radius: 4px;
        --border-input: 0.1rem solid rgba(0, 0, 0, 0.25);
        --font-size-xl: 2.375rem;
        --font-size-l: 1.875rem;
        --font-size-m: 1rem;
        --font-size-s: 0.875rem;
        --font-size-xs: 0.75rem;
        --font-weight-bold: 700;
        --primary-900: #00903b;
        --primary-800: #00b253;
        --primary-700: #00c560;
        --primary-600: #00d96f;
        --primary-500: #00eb7c;
        --primary-400: #00f28f;
        --primary-300: #00fba1;
        --primary-200: #00ffbb;
        --primary-100: #9bffd6;
        --primary-50: #d8ffef;
        --primary-erm-green: #00ffbc;

        --secondary-900: #005da0;
        --secondary-800: #007ec2;
        --secondary-700: #008dd6;
        --secondary-erm-blue: #008dd6;
        --secondary-600: #04a2ea;
        --secondary-500: #07b0f9;
        --secondary-400: #2cbcfa;
        --secondary-300: #52c9fa;
        --secondary-200: #83d8fc;
        --secondary-100: #b4e7fd;
        --secondary-50: #e2f6fe;

        --grey-color-900: #1b1b1b;
        --grey-color-800: #3c3c3c;
        --grey-color-700: #5a5a5a;
        --grey-color-600: #6e6e6e;
        --grey-color-500: #969696;
        --grey-color-400: #b6b6b6;
        --grey-color-300: #dadada;
        --grey-color-200: #e9e9e9;
        --grey-color-100: #f2f2f2;
        --grey-color-50: #f9f9f9;

        --blue-grey-scale-900: #141c20;
        --blue-grey-scale-800: #343d41;
        --blue-grey-scale-700: #535b60;
        --blue-grey-scale-600: #666f74;
        --blue-grey-scale-erm: #666f74;
        --blue-grey-scale-500: #8e989d;
        --blue-grey-scale-400: #aeb7bd;
        --blue-grey-scale-300: #d1dbe1;
        --blue-grey-scale-200: #e1ebf1;
        --blue-grey-scale-100: #eaf4fa;
        --blue-grey-scale-50: #f0fbff;

        --green-grey-scale-900: #102414;
        --green-grey-scale-800: #35423c;
        --green-grey-scale-700: #536059;
        --green-grey-scale-600: #66726c;
        --green-grey-scale-500: #9ca59e;
        --green-grey-scale-400: #c0c9c4;
        --green-grey-scale-300: #d6dfda;
        --green-grey-scale-200: #e3e9e6;
        --green-grey-scale-100: #edf2f0;
        --green-grey-scale-50: #f6f6f6;

        --green-grey-scale-cold-tones-cold-tones-900: #102414;
        --green-grey-scale-cold-tones-cold-tones-800: #35423c;
        --green-grey-scale-cold-tones-cold-tones-700: #536059;
        --green-grey-scale-cold-tones-cold-tones-600: #66726c;
        --green-grey-scale-cold-tones-cold-tones-500: #9ca59e;
        --green-grey-scale-cold-tones-cold-tones-400: #c0c9c4;
        --green-grey-scale-cold-tones-cold-tones-300: #d6dfda;
        --green-grey-scale-cold-tones-cold-tones-200: #e3e9e6;
        --green-grey-scale-cold-tones-cold-tones-100: #edf2f0;
        --green-grey-scale-cold-tones-cold-tones-50: #f6f6f6;

        --success-color: #00b929;
        --success-color-hover: #4ce16d;
        --success-color-pressed: #0e9c2e;

        --error-color: #fa2a2a;
        --error-color-hover: #ff8787;
        --error-color-pressed: #d61111;

        --need-review-color: #fb8b3b;

        --dark-green-900: #0a2b14;
        --dark-green-800: #154528;
        --dark-green-700: #1d5434;
        --dark-green-600: #23623f;
        --dark-green-500: #276d48;
        --dark-green-400: #39815d;
        --dark-green-300: #539674;
        --dark-green-200: #7fb399;
        --dark-green-100: #afd1c0;
        --dark-green-50: #deece6;

        --medium-green-900: #014e20;
        --medium-green-800: #106c32;
        --medium-green-700: #197d3c;
        --medium-green-600: #228f47;
        --medium-green-500: #2a9d50;
        --medium-green-400: #4dab69;
        --medium-green-300: #6db982;
        --medium-green-200: #97cca5;
        --medium-green-100: #c0e0c8;
        --medium-green-50: #e5f3e8;

        --green-900: #005900;
        --green-800: #007802;
        --green-700: #008813;
        --green-600: #019a20;
        --green-500: #14a929;
        --green-400: #47b64c;
        --green-300: #6cc26d;
        --green-200: #98d397;
        --green-100: #c1e4c0;
        --green-50: #e5f4e5;

        --primary-mint-900: #00903b;
        --primary-mint-800: #00b253;
        --primary-mint-700: #00c560;
        --primary-mint-600: #00d96f;
        --primary-mint-500: #00eb7c;
        --primary-mint-400: #00f28f;
        --primary-mint-300: #00fba1;
        --primary-mint-200: #00ffbb;
        --primary-mint-100: #9bffd6;
        --primary-mint-50: #d8ffef;
        --primary-primary-mint-green-200: #00ffbc;

        --soft-black-gray-scale-900: #282828;
        --soft-black-gray-scale-800: #4a4a4a;
        --soft-black-gray-scale-700: #696969;
        --soft-black-gray-scale-600: #7e7e7e;
        --soft-black-gray-scale-500: #a7a7a7;
        --soft-black-gray-scale-400: #c6c6c6;
        --soft-black-gray-scale-300: #e8e8e8;
        --soft-black-gray-scale-200: #f2f2f2;
        --soft-black-gray-scale-100: #f6f6f6;
        --soft-black-gray-scale-50: #fbfbfb;
        --soft-black-gray-scale-100-white: #fff;

        --dark-gray-900: #0d1205;
        --dark-gray-800: #2e3229;
        --dark-gray-700: #4b5046;
        --dark-gray-600: #5e6358;
        --dark-gray-500: #858a7f;
        --dark-gray-400: #a6aba0;
        --dark-gray-300: #cbd0c4;
        --dark-gray-200: #dee3d7;
        --dark-gray-100: #eaefe3;
        --dark-gray-50: #f3f9ed;

        --light-gray-900: #001500;
        --light-gray-800: #001700;
        --light-gray-700: #001800;
        --light-gray-600: #001b00;
        --light-gray-500: #002100;
        --light-gray-400: #003600;
        --light-gray-300: #005119;
        --light-gray-200: #517e55;
        --light-gray-100: #95b196;
        --light-gray-50: #d3dfd4;

        --yellow: #ffeb3b;
        --yellow-50: #fffde7;
        --yellow-100: #fff9c4;
        --yellow-200: #fff59d;
        --yellow-300: #fff176;
        --yellow-400: #ffee58;
        --yellow-500: var(--yellow);
        --yellow-600: #fdd835;
        --yellow-700: #fbc02d;
        --yellow-800: #f9a825;
        --yellow-900: #f57f17;

        --blue: #2196f3;
        --blue-50: #e3f2fd;
        --blue-100: #bbdefb;
        --blue-200: #90caf9;
        --blue-300: #64b5f6;
        --blue-400: #42a5f5;
        --blue-500: var(--blue);
        --blue-600: #1e88e5;
        --blue-700: #1976d2;
        --blue-800: #1565c0;
        --blue-900: #0d47a1;
        --blue-a100: #82b1ff;
        --blue-a200: #448aff;
        --blue-a400: #2979ff;
        --blue-a700: #2962ff;
      }
    `}
  />
);
